import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { userInfoApiSlice } from '../../api/rtk/base/slices/userInfoApiSlice';
import { Loader } from '../../widgets/loaders/Loader';
import { getItemWebStorage } from '../../features/webStorageSaver/webStorageSaver';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';
import ToastMessageContainer from '../../widgets/toastMessageContainer/ToastMessageContainer';
import { useDispatch } from 'react-redux';
import { setToastMessageContainerClearButtonIsClicked, showToastMessage } from '../../stateManagement/reducers';

// функция для получения информация об ОС пользователя
function getOS() {
    let userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;
    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (!os && /Linux/.test(platform)) {
        os = 'Linux';
    }
    return os;
}

// функция для получения версии браузера пользователя
function getBrowserVersion() {
    const userAgent = navigator.userAgent;
    const browserName: any = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(browserName[0])) {
        const rv = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return `IE ${rv[1] || ''}`;
    }
    const version = browserName[2] ? browserName[2] : null;
    return version;
}

// функция для получения названия браузера пользователя
function getBrowserType() {
    const test = (regexp: any) => {
        return regexp.test(navigator.userAgent);
    };
    if (test(/opr\//i)) {
        return 'Opera';
    } else if (test(/edg/i)) {
        return 'Microsoft Edge';
    } else if (test(/chrome|chromium|crios/i)) {
        return 'Chrome';
    } else if (test(/firefox|fxios/i)) {
        return 'Mozilla Firefox';
    } else if (test(/safari/i)) {
        return 'Apple Safari';
    } else if (test(/trident/i)) {
        return 'Microsoft Internet Explorer';
    } else if (test(/ucbrowser/i)) {
        return 'UC Browser';
    } else if (test(/samsungbrowser/i)) {
        return 'Samsung Browser';
    } else {
        return '—';
    }
}

// функция изменения стиля строк значений с не указанным значением
export function changeNoValueStyle() {
    Array.prototype.forEach.call(document.getElementsByClassName("value"), function (el) {
        if (el.innerHTML == "не указано") {
            el.classList.add("basic-info-no-value")
        } else if (el.innerHTML != "не указано") {
            el.classList.add("basic-info-value")
        }
    })
}

// Страница отображения информации о пользователе
export function BasicInfoPage() {
    const dispatch = useDispatch()
    const browserType = getBrowserType();
    const browserVersion = getBrowserVersion()
    const OS = getOS()
    // запрос на получение информации о пользователе
    const {
        data: userInfo,
        isFetching: isFetchingUserInfo,
        isError: userInfoError
    } = userInfoApiSlice.useFetchUserInfoQuery({})
    const currentConfig = getItemWebStorage('currentConfig')
    const dataCenter = currentConfig.serverName
    const { Login, Position, OrganizationName, Email, Description, DepartmentName, Phone }: any = userInfo ? userInfo : {}

    // изменение стиля строк с отсутствующим значением при поднятии компонента
    useEffect(() => {
        changeNoValueStyle();
    }, [userInfo]);

    useEffect(() => {
        if (userInfoError) {
            dispatch(showToastMessage({ messageText: 'Не удалось загрузить информацию о пользователе', messageType: "error" }))
        }
    }, [userInfoError])

    useEffect(() => {
        if (isFetchingUserInfo) {
            dispatch(setToastMessageContainerClearButtonIsClicked(true))
        }
    }, [isFetchingUserInfo])

    return (
        <>
            <ContentHeader title="Информация" />
            <div className="basic-info-div ">
                <ToastMessageContainer />
                {!isFetchingUserInfo
                    ?
                    <>
                        {!userInfoError
                            ?
                            <>
                                <Row>
                                    <div className="section-name">Информация о пользователе</div>
                                </Row>
                                <Row xs={1} md={2} lg={4} xxl={6}>
                                    <Col className="field" >Логин</Col>
                                    <Col className="value" >{Login}</Col>
                                    <Col className="field" >Должность</Col>
                                    <Col className="value" >{Position}</Col>
                                    <Col className="field" >Организация</Col>
                                    <Col className="value">{OrganizationName}</Col>
                                    <Col className="field" >Электронная почта</Col>
                                    <Col className="value">{Email}</Col>
                                    <Col className="field" >ФИО пользователя</Col>
                                    <Col className="value">{Description}</Col>
                                    <Col className="field" >Подразделение</Col>
                                    <Col className="value">{DepartmentName}</Col>
                                    <Col className="field" >Номер телефона</Col>
                                    <Col className="value">{Phone}</Col>
                                </Row>
                                <Row>
                                    <div className="section-name">Информация о системе</div>
                                </Row>
                                <Row xs={1} md={2} lg={4} xxl={6}>
                                    <Col className="field" >Браузер</Col>
                                    <Col className="value">{browserType}</Col>
                                    <Col className="field" >Версия браузера</Col>
                                    <Col className="value">{browserVersion}</Col>
                                    <Col className="field" >Операционная система</Col>
                                    <Col className="value">{OS}</Col>
                                </Row>
                                <Row>
                                    <div className="section-name">Информация о дата-центре</div>
                                </Row>
                                <Row xs={1} md={2} lg={4} xxl={6}>
                                    <Col className="field" >Дата-центр</Col>
                                    <Col className="value">{dataCenter}</Col>
                                </Row>
                            </>
                            :
                            <></>
                        }
                    </>
                    :
                    <Loader />
                }
            </div>

        </>
    );
}

